"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayType = exports.MasterType = void 0;
var MasterType;
(function (MasterType) {
    /** 取引先 */
    MasterType["PARTNER"] = "partner";
    /** 税区分 */
    MasterType["TAX_DIV"] = "tax_div";
    /**
     * 勘定科目
     * @deprecated use ACCOUNTING_TYPE instead
     */
    MasterType["JOURNAL"] = "journal";
    /** 勘定科目 */
    MasterType["ACCOUNTING_TYPE"] = "journal";
    /** 勘定科目（かがみ） */
    MasterType["ACCOUNTING_TYPE_HEADER"] = "accountingTypeHeader";
    /** 部署 */
    MasterType["DEPARTMENT"] = "department";
    /** 証憑（マスタじゃないが） */
    MasterType["VOUCHER"] = "voucher";
    /** カスタム辞書（汎用リスト） */
    MasterType["CUSTOM_LIST"] = "custom_list";
    MasterType["CONCUR_USER"] = "concur_user";
    /** @deprecated */
    MasterType["CONCUR_VENDOR"] = "concur_vendor";
    /** @deprecated */
    MasterType["CONCUR_EXPENSE_TYPE"] = "concur_expense_type";
})(MasterType = exports.MasterType || (exports.MasterType = {}));
exports.DisplayType = {
    PULLDOWN: "pulldown",
    DISPLAY: "display",
};
